import React, { useEffect } from 'react';
import { Form, Input, Card, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { notEmptyRule, optionalNotWhitespaceRule } from './validationUtils';

const { TextArea } = Input;

const HoursSection = ({ 
  sectionKey, 
  sectionData, 
  currentLanguage,
  form
}) => {
  const { t } = useTranslation();
  
  // Create dynamic field names based on current language
  const langKey = currentLanguage.toLowerCase();
  const getFieldName = (field) => {
    // Split the field path into parts
    const parts = field.split('.');
    // Return the full path array
    return ['content', langKey, sectionKey, ...parts];
  };

  // Initialize default structure if no data exists
  useEffect(() => {
    const workingHoursFieldName = getFieldName('working_hours_section');
    const extraordinaryHoursFieldName = getFieldName('extraordinary_hours_section');
    
    const currentWorkingHours = form.getFieldValue(workingHoursFieldName);
    const currentExtraordinaryHours = form.getFieldValue(extraordinaryHoursFieldName);
    
    // Initialize working hours section if it doesn't exist
    if (!currentWorkingHours) {
      form.setFieldsValue({
        [workingHoursFieldName.join('.')]: { title: '', description: '' }
      });
    }
    
    // Initialize extraordinary hours section if it doesn't exist
    if (!currentExtraordinaryHours) {
      form.setFieldsValue({
        [extraordinaryHoursFieldName.join('.')]: { title: '', description: '' }
      });
    }
  }, []);

  // Debug logging
  useEffect(() => {
    console.log('=== Hours Section Debug ===');
    console.log('sectionKey:', sectionKey);
    console.log('sectionData:', sectionData);
    console.log('currentLanguage:', currentLanguage);
    console.log('form values:', form.getFieldsValue());
    console.log('working_hours_section path:', getFieldName('working_hours_section.title'));
    console.log('extraordinary_hours_section path:', getFieldName('extraordinary_hours_section.title'));
  }, [sectionKey, sectionData, currentLanguage]);

  return (
    <>
      {/* Working Hours Section */}
      <Card title={t('Orari di Lavoro')} size='small' style={{ marginBottom: 16 }}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name={getFieldName('working_hours_section.title')}
              label={t('Titolo')}
              rules={[notEmptyRule(t, 'Il campo non può essere vuoto')]}
            >
              <Input placeholder={t('Inserisci il titolo')} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={getFieldName('working_hours_section.description')}
              label={t('Descrizione')}
              rules={[notEmptyRule(t, 'Il campo non può essere vuoto')]}
            >
              <TextArea rows={3} placeholder={t('Inserisci la descrizione')} />
            </Form.Item>
          </Col>
        </Row>
      </Card>

      {/* Extraordinary Hours Section */}
      <Card title={t('Orari Straordinari')} size='small'>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name={getFieldName('extraordinary_hours_section.title')}
              label={t('Titolo')}
              rules={[optionalNotWhitespaceRule(t, 'Il titolo non può contenere solo spazi vuoti')]}
            >
              <Input placeholder={t('Inserisci il titolo')} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={getFieldName('extraordinary_hours_section.description')}
              label={t('Descrizione')}
              rules={[optionalNotWhitespaceRule(t, 'La descrizione non può contenere solo spazi vuoti')]}
            >
              <TextArea rows={3} placeholder={t('Inserisci la descrizione')} />
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default HoursSection; 